import { defineComponent } from 'vue';
export const optionProps = {
    value: String,
    disabled: Boolean,
    label: [String, Number, Function],
};
export default defineComponent({
    name: 'Option',
    props: optionProps,
    render(_props, { slots }) {
        return slots.default?.();
    },
});
